import { useState, useCallback, useContext, useMemo } from 'react'
import { VerticalContext } from 'store/verticals/Context'
import type { RawApiGraphData } from './core/types'

export interface UseNetworkGraphReturn {
  /** Whether the graph overlay is visible */
  isOpen: boolean
  /** The graph data (raw API format) */
  graphData: RawApiGraphData | null
  /** Open the network graph overlay */
  open: () => void
  /** Close the network graph overlay */
  close: () => void
}

/**
 * Hook for managing network graph state.
 * Reads graph data from verticalEntity.graph (already fetched with entity data).
 */
export function useNetworkGraph(): UseNetworkGraphReturn {
  const [isOpen, setIsOpen] = useState(false)
  const { verticalEntity } = useContext(VerticalContext)

  const graphData = useMemo<RawApiGraphData | null>(() => {
    const graph = (verticalEntity as any)?.graph
    if (graph && graph.nodes?.length > 0) {
      return graph as RawApiGraphData
    }
    return null
  }, [verticalEntity])

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isOpen,
    graphData,
    open,
    close,
  }
}
